import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { DEFAULT_THEME } from "../../constants/theme";

export default function CounselingPortalTooltip({ content, children, theme = DEFAULT_THEME }) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 10,
        left: rect.left + rect.width / 2,
      });
      setVisible(true);
    }
  };

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setVisible(false)}
        className="inline-block relative"
      >
        {children}
      </div>
      {visible &&
        createPortal(
          <div className="fixed z-[99999] pointer-events-none" style={{ top: position.top, left: position.left }}>
            <div className={`relative -translate-x-1/2 -translate-y-full mb-2 ${theme.bg.replace("bg-", "bg-")}/95 backdrop-blur-md text-white text-xs font-bold px-3 py-1.5 rounded-xl shadow-xl border border-white/20 whitespace-nowrap`}>
              {content}
              <div className={`absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-${theme.bg.replace("bg-", "").replace("]", "]/95")}`}></div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
